// src/services/cacheService.js

// Generic save function
export const saveToCache = async (key, data) => {
  try {
    const cacheData = {
      data: data,
      timestamp: Date.now(),
      version: 1
    };
    localStorage.setItem(`erp_cache_${key}`, JSON.stringify(cacheData));
    console.log(`✅ Cached: ${key}`);
    return true;
  } catch (error) {
    console.error(`Failed to cache ${key}:`, error);
    return false;
  }
};

// Generic get function
export const getFromCache = (key) => {
  try {
    const cached = localStorage.getItem(`erp_cache_${key}`);
    if (!cached) return null;
    
    const cacheData = JSON.parse(cached);
    return cacheData.data;
  } catch (error) {
    console.error(`Failed to read cache ${key}:`, error);
    return null;
  }
};

// Check if cache exists
export const hasCache = (key) => {
  return localStorage.getItem(`erp_cache_${key}`) !== null;
};

// Clear all caches
export const clearAllCache = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith('erp_cache_')) {
      localStorage.removeItem(key);
    }
  });
  console.log('🗑️ All caches cleared');
};

// Get offline status
export const isOffline = () => !navigator.onLine;

// Specific cache functions for each component
export const cacheOrders = (data) => saveToCache('orders', data);
export const getCachedOrders = () => getFromCache('orders');

export const cachePayments = (data) => saveToCache('payments', data);
export const getCachedPayments = () => getFromCache('payments');

export const cacheExpenses = (data) => saveToCache('expenses', data);
export const getCachedExpenses = () => getFromCache('expenses');

export const cacheInventory = (data) => saveToCache('inventory', data);
export const getCachedInventory = () => getFromCache('inventory');

export const cacheFinishedGoods = (data) => saveToCache('finishedgoods', data);
export const getCachedFinishedGoods = () => getFromCache('finishedgoods');

export const cacheMarketplace = (data) => saveToCache('marketplace', data);
export const getCachedMarketplace = () => getFromCache('marketplace');

export const cacheCapital = (data) => saveToCache('capital', data);
export const getCachedCapital = () => getFromCache('capital');

export const cacheAssets = (data) => saveToCache('assets', data);
export const getCachedAssets = () => getFromCache('assets');

export const cacheAmbassadors = (data) => saveToCache('ambassadors', data);
export const getCachedAmbassadors = () => getFromCache('ambassadors');

export const cacheDashboard = (data) => saveToCache('dashboard', data);
export const getCachedDashboard = () => getFromCache('dashboard');